export function isValidQuestionAsset(value) {
  return value && value !== "null" && value !== "undefined";
}
